import { CoreButton, CoreModalDialog } from '@components'
import AddReportIcon from '@images/expenses/add-report.svg?react'

import AddExpenseButton from '@views/expenseManagement/@elements/AddExpenseButton'
import { tr } from 'mmfintech-commons'
import { useState } from 'react'
import { ReportEditModal } from '../components'

import './reportActionsHeader.scss'

export const ReportActionsHeader = () => {
  const [isReportCreateModalVisible, setIsReportCreateModalVisible] = useState<boolean>(false)

  const handleCreateModalOpen = () => setIsReportCreateModalVisible(true)
  const handleCreateModalClose = () => setIsReportCreateModalVisible(false)

  return (
    <div className='reports-actions'>
      <AddExpenseButton />

      <CoreButton
        text={tr('FRONTEND.EXPENSE_MANAGEMENT.ADD_REPORT', 'Add Report')}
        LeftIcon={<AddReportIcon />}
        data-test='button-add-report'
        onClick={handleCreateModalOpen}
        size='large'
      />

      <CoreModalDialog
        header={tr('FRONTEND.REPORTS.CREATE.CREATE_NEW_REPORT', 'Create New Report')}
        options={{ closeOnEscape: false, closeOnClickOutside: false }}
        visible={isReportCreateModalVisible}
        content={<ReportEditModal onClose={handleCreateModalClose} />}
        onClose={handleCreateModalClose}
      />
    </div>
  )
}
